var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "h-full flex flex-col",
    attrs: {
      id: "app"
    }
  }, [_c("RouterView", {
    staticClass: "flex-1 overflow-auto"
  }), _vm.hasMain ? _c("TabBar", {
    attrs: {
      data: _vm.tabBars,
      "default-active": _vm.active
    }
  }) : _vm._e(), _vm.showGuide ? _c("div", {
    staticClass: "fixed right-0 top-0 w-full h-full z-[2200] bg-black/50"
  }, [_c("img", {
    staticClass: "absolute top-[18px] right-[18px] w-[130px] h-[116px]",
    attrs: {
      alt: "",
      src: "https://obs.prod.ubanquan.cn/obs_011600737300001660119551_pre$prod-ubq"
    }
  })]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };